<template>
  <div class="page-home">
    <LandingPage
      v-if="defer(10)"
      :column-list="homeColumnList"
      class="sp-landing-page"
    ></LandingPage>
    <section
      v-if="defer(10)"
      ref="homeTab"
      class="category-lp home-category-lp widget-widget-tab-sticky-to-top"
    >
      <Tab :data="tabData" style="width: 100%">
        <template slot-scope="{ subData, index }">
          <LandingPage :key="index" :column-list="subData.list"></LandingPage>
        </template>
      </Tab>
    </section>
    <div class="follow-us">
      <div class="widget-widget-svg-big-title">
        <div class="sp-landing-textblock">
          <svg
            v-if="isMobile"
            width="144"
            height="93"
            viewBox="0 0 144 93"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.45381 6.46802L4.62781 6.91602C4.38981 6.24402 3.80181 5.25002 3.24181 4.52201L3.99781 4.11601C4.59981 4.83001 5.18781 5.82402 5.45381 6.46802ZM13.0418 11.41H7.81981C8.85581 13.538 10.7878 15.106 13.3638 15.764C13.1398 15.96 12.8458 16.366 12.7058 16.632C10.2138 15.876 8.35181 14.308 7.18981 12.096C6.60181 13.734 5.10381 15.4 1.43581 16.716C1.32381 16.506 1.01581 16.114 0.777813 15.904C4.57181 14.602 5.87381 12.95 6.30781 11.41H1.02981V10.486H6.48981C6.51781 10.164 6.53181 9.87002 6.53181 9.57602V7.88201H1.85581V6.97201H8.43581C8.99581 6.13201 9.62581 4.91402 9.98981 4.03202L10.9838 4.38201C10.5358 5.23601 9.96181 6.20201 9.42981 6.97201H12.2858V7.88201H7.56781V9.59002C7.56781 9.88402 7.55381 10.178 7.52581 10.486H13.0418V11.41ZM23.7658 6.18801L22.8698 6.55202C22.6738 5.93601 22.1558 4.95601 21.6798 4.22802L22.5198 3.92001C23.0098 4.62002 23.5558 5.58602 23.7658 6.18801ZM18.5578 5.60002L18.0118 6.35602C17.4238 5.90802 16.2898 5.23601 15.3798 4.80202L15.8838 4.13001C16.7798 4.53602 17.9558 5.15201 18.5578 5.60002ZM17.7458 9.38002L17.2278 10.164C16.6538 9.71602 15.5338 9.07202 14.6518 8.63802L15.1698 7.95202C16.0098 8.35802 17.1578 8.96002 17.7458 9.38002ZM17.7178 11.424L18.3898 12.026C17.6618 13.496 16.6678 15.26 15.8558 16.562L15.0718 15.918C15.8278 14.854 16.9198 13.006 17.7178 11.424ZM23.3318 15.386H27.4058V16.282H18.2078V15.386H22.3798V11.662H19.1878V10.78H22.3798V7.53202H18.6418V6.63602H27.0978V7.53202H23.3318V10.78H26.5798V11.662H23.3318V15.386ZM40.8318 6.67802L40.0758 7.22401C39.6278 6.56602 38.6758 5.55801 37.8358 4.83001L38.5498 4.35402C39.3758 5.04001 40.3558 6.03402 40.8318 6.67802ZM39.6698 9.67402L40.4958 10.024C39.8658 11.214 39.0258 12.348 38.0458 13.356C38.5778 14.91 39.2498 15.834 40.0058 15.834C40.3978 15.834 40.5798 15.106 40.6638 13.3C40.8598 13.482 41.1958 13.692 41.4478 13.79C41.2798 16.086 40.9298 16.772 39.9218 16.772C38.8018 16.772 37.9338 15.75 37.2898 14.084C36.3658 14.896 35.3298 15.624 34.2798 16.198C34.1258 15.96 33.8458 15.652 33.6218 15.456C34.8118 14.868 35.9598 14.07 36.9678 13.132C36.6318 11.956 36.3658 10.556 36.1838 9.00202H32.8098V11.368C33.6498 11.186 34.5038 10.99 35.3578 10.794L35.4278 11.634L32.8098 12.25V15.484C32.8098 16.128 32.6418 16.408 32.2358 16.562C31.8018 16.716 31.0738 16.758 29.9258 16.744C29.8838 16.478 29.7158 16.072 29.5758 15.806C30.4858 15.834 31.3118 15.82 31.5498 15.806C31.8018 15.806 31.8858 15.736 31.8858 15.484V12.474C30.8078 12.74 29.7718 12.964 28.9178 13.16L28.6518 12.222C29.5058 12.068 30.6538 11.83 31.8858 11.55V9.00202H28.8338V8.12002H31.8858V5.75402C30.9898 5.93601 30.0938 6.09002 29.2398 6.21602C29.1978 5.99202 29.0578 5.67001 28.9458 5.44602C30.8918 5.13802 33.1738 4.64801 34.4758 4.15802L35.1478 4.92802C34.4758 5.15201 33.6778 5.37602 32.8098 5.57202V8.12002H36.0858C35.9738 6.84601 35.9038 5.47401 35.8898 4.08802H36.8558C36.8558 5.51602 36.9118 6.86002 37.0378 8.12002H41.1958V9.00202H37.1358C37.2898 10.262 37.4858 11.382 37.7378 12.362C38.5218 11.522 39.1798 10.626 39.6698 9.67402ZM45.2558 4.06001L46.0958 4.28402C45.8158 5.30602 45.4378 6.34202 45.0318 7.29401V16.716H44.1358V9.12802C43.7998 9.71602 43.4638 10.248 43.0998 10.724C43.0158 10.514 42.7498 10.024 42.5818 9.81402C43.6878 8.38602 44.6538 6.21602 45.2558 4.06001ZM46.8098 16.73V6.73402H47.7198V16.73H46.8098ZM47.3978 4.35402L48.1258 3.99001C48.7418 4.83001 49.4558 5.96402 49.7918 6.66402L49.0218 7.09801C48.7138 6.38401 48.0138 5.22201 47.3978 4.35402ZM54.8598 4.49402V15.484C54.8598 16.1 54.7058 16.366 54.2998 16.52C53.8938 16.688 53.1798 16.688 52.1018 16.688C52.0598 16.45 51.9058 16.044 51.7798 15.792C52.6058 15.82 53.3898 15.82 53.6138 15.806C53.8518 15.792 53.9358 15.722 53.9358 15.484V5.34801H50.0718V4.49402H54.8598Z"
              fill="#14141E"
            />
            <path
              d="M27.0078 26.4941V28.4629H35.0234V32.1191H27.0078V33.3848H21.3828V32.1191H15.4766V33.2441H13.0859L15.6172 35.6348C15.1484 35.916 14.4453 36.3379 13.5078 36.9004C12.6641 37.3691 12.0078 37.7441 11.5391 38.0254C12.7578 40.1816 13.3672 43.041 13.3672 46.6035C13.3672 46.6973 13.3203 46.8848 13.2266 47.166C13.2266 47.4473 13.2266 47.6816 13.2266 47.8691C17.2578 46.0879 19.5078 43.8848 19.9766 41.2598H14.0703V37.7441H20.2578C20.3516 36.9941 20.3984 35.7285 20.3984 33.9473H26.0234C25.9297 35.3535 25.8828 36.6191 25.8828 37.7441H29.8203C29.4453 37.4629 28.8828 37.041 28.1328 36.4785C27.5703 36.0098 27.1016 35.6348 26.7266 35.3535L29.2578 32.9629C29.7266 33.3379 30.3828 33.8066 31.2266 34.3691C32.1641 34.9316 32.8672 35.4004 33.3359 35.7754L31.3672 37.7441H34.4609V41.2598H26.4453C27.5703 44.2598 30.4297 46.3691 35.0234 47.5879C34.7422 47.9629 34.2734 48.666 33.6172 49.6973C33.0547 50.6348 32.6328 51.291 32.3516 51.666C28.0391 50.3535 25.0859 48.2441 23.4922 45.3379C22.2734 47.7754 19.6953 49.9316 15.7578 51.8066C15.4766 51.6191 14.8672 50.9629 13.9297 49.8379C13.5547 49.3691 13.2734 49.041 13.0859 48.8535C12.5234 50.7285 10.7891 51.666 7.88281 51.666C6.75781 51.666 5.25781 51.666 3.38281 51.666C3.19531 51.0098 2.91406 49.9316 2.53906 48.4316C3.94531 48.4316 5.16406 48.4316 6.19531 48.4316C7.69531 48.5254 8.39844 47.8691 8.30469 46.4629C8.30469 45.9004 8.30469 45.3848 8.30469 44.916C6.14844 46.2285 4.22656 47.2598 2.53906 48.0098C2.35156 47.541 1.97656 46.791 1.41406 45.7598C1.13281 45.291 0.945312 44.916 0.851562 44.6348C3.47656 43.5098 5.72656 42.3379 7.60156 41.1191C7.60156 41.0254 7.55469 40.8848 7.46094 40.6973C7.36719 40.416 7.27344 40.2285 7.17969 40.1348C5.86719 40.791 4.36719 41.4004 2.67969 41.9629C1.92969 40.6504 1.32031 39.5254 0.851562 38.5879C1.50781 38.4004 2.49219 38.0723 3.80469 37.6035C4.36719 37.416 4.78906 37.2754 5.07031 37.1816C4.13281 36.2441 3.14844 35.4941 2.11719 34.9316L5.77344 32.4004C7.17969 33.2441 8.35156 34.1348 9.28906 35.0723C9.66406 34.8848 10.2266 34.5566 10.9766 34.0879C11.5391 33.7129 11.9609 33.4316 12.2422 33.2441H9.71094V32.1191H0.992188V28.4629H9.71094V26.4941H15.4766V28.4629H21.3828V26.4941H27.0078ZM54.9922 47.3066C54.8047 47.3066 54.5234 47.3535 54.1484 47.4473C53.7734 47.4473 53.4922 47.4941 53.3047 47.5879V51.666H48.3828V48.1504C47.5391 48.2441 46.3203 48.3848 44.7266 48.5723C41.6328 48.9473 39.1953 49.2285 37.4141 49.416L36.7109 45.4785C36.9922 45.4785 37.3672 45.4785 37.8359 45.4785C38.3984 45.3848 38.8203 45.3379 39.1016 45.3379V31.416H37.4141V27.7598H54.5703V31.416H53.3047V43.791C53.4922 43.791 53.7734 43.791 54.1484 43.791C54.5234 43.6973 54.8516 43.6504 55.1328 43.6504C55.0391 45.1504 54.9922 46.3691 54.9922 47.3066ZM59.9141 32.541C60.4766 36.1973 61.3203 38.916 62.4453 40.6973C63.5703 38.6348 64.3672 35.8691 64.8359 32.4004H55.1328V28.4629H70.0391V32.4004C69.2891 37.5566 67.8828 41.5879 65.8203 44.4941C66.7578 45.3379 68.5391 46.416 71.1641 47.7285C70.4141 48.8535 69.5234 50.166 68.4922 51.666C66.1484 50.6348 64.1328 49.4629 62.4453 48.1504C60.8516 49.5566 58.9297 50.8223 56.6797 51.9473C56.1172 51.3848 55.0859 50.166 53.5859 48.291C55.8359 47.0723 57.7109 45.8535 59.2109 44.6348C57.1484 42.0098 55.7422 38.3066 54.9922 33.5254L59.9141 32.541ZM43.8828 36.9004V39.1504H48.3828V36.9004H43.8828ZM43.8828 31.416V33.8066H48.3828V31.416H43.8828ZM43.8828 44.7754C45.4766 44.5879 46.9766 44.4473 48.3828 44.3535V42.2441H43.8828V44.7754Z"
              fill="#14141E"
            />
            <path
              d="M1.41406 83.2441L0.992188 80.1504C1.83594 80.1504 2.67969 80.1504 3.52344 80.1504V71.5723H0.992188V68.6191H35.0234V71.5723H18.1484V79.4473L19.8359 79.3066C19.7422 79.6816 19.6953 80.0566 19.6953 80.4316C20.6328 80.1504 21.5234 79.8691 22.3672 79.5879C21.2422 78.7441 20.2109 77.7598 19.2734 76.6348L21.5234 75.5098H18.8516V72.5566H33.4766V75.9316C33.2891 76.1191 33.0078 76.4473 32.6328 76.916C32.1641 77.5723 31.3672 78.416 30.2422 79.4473C31.6484 79.8223 33.2891 80.1504 35.1641 80.4316C35.0703 80.7129 34.8359 81.0879 34.4609 81.5566C33.8984 82.5879 33.4766 83.291 33.1953 83.666C30.3828 83.291 28.0859 82.6816 26.3047 81.8379C24.6172 82.6816 22.6016 83.3379 20.2578 83.8066C19.9766 83.6191 19.6016 83.1504 19.1328 82.4004C18.7578 82.4004 18.4297 82.4004 18.1484 82.4004V83.666H13.2266V82.6816C8.53906 82.8691 4.60156 83.0566 1.41406 83.2441ZM31.3672 59.4785V67.916H4.64844V59.4785H31.3672ZM10.2734 65.5254H25.7422V64.6816H10.2734V65.5254ZM10.2734 62.0098V62.8535H25.7422V62.0098H10.2734ZM23.6328 75.5098C24.4766 76.3535 25.3672 77.0566 26.3047 77.6191C26.4922 77.5254 26.7266 77.3379 27.0078 77.0566C27.7578 76.4941 28.3203 75.9785 28.6953 75.5098H23.6328ZM8.44531 79.8691C8.91406 79.8691 9.66406 79.8691 10.6953 79.8691C11.8203 79.7754 12.6641 79.7285 13.2266 79.7285V78.6035H8.44531V79.8691ZM8.44531 75.0879V76.3535H13.2266V75.0879H8.44531ZM8.44531 71.5723V72.8379H13.2266V71.5723H8.44531ZM39.5234 75.0879L43.1797 76.6348C42.6172 77.7598 42.0078 78.8848 41.3516 80.0098C41.5391 80.1035 41.7734 80.1504 42.0547 80.1504C42.4297 80.0566 42.6641 80.0098 42.7578 80.0098C43.6953 80.1035 44.1172 79.6816 44.0234 78.7441V74.9473H37.6953V71.5723H44.0234V70.3066H37.1328V66.9316H40.6484C40.0859 66.1816 39.4766 65.5254 38.8203 64.9629L40.9297 63.9785H37.8359V60.6035H43.3203C43.2266 60.3223 43.0859 59.9473 42.8984 59.4785C42.8047 59.0098 42.7109 58.6816 42.6172 58.4941L48.6641 58.0723C48.7578 58.4473 48.8516 58.916 48.9453 59.4785C49.1328 59.9473 49.2266 60.3223 49.2266 60.6035H54.5703V63.9785H51.4766L53.8672 64.6816C53.6797 64.8691 53.3516 65.2441 52.8828 65.8066C52.5078 66.2754 52.1797 66.6504 51.8984 66.9316H55.1328V70.3066H49.2266V71.5723H54.7109V74.9473H49.2266V76.916L52.6016 75.2285C52.7891 75.6035 53.1172 76.0723 53.5859 76.6348C53.9609 77.0098 54.3828 77.6191 54.8516 78.4629C55.6016 77.0566 55.9297 74.3848 55.8359 70.4473V60.3223C61.7422 60.041 66.2422 59.6191 69.3359 59.0566L70.6016 62.8535C69.1953 63.041 66.9453 63.2754 63.8516 63.5566C62.7266 63.5566 61.8359 63.6035 61.1797 63.6973V66.9316H71.0234V70.7285H68.3516V83.5254H63.2891V70.7285H61.1797C61.1797 76.541 60.1484 80.9004 58.0859 83.8066C57.8047 83.7129 57.3359 83.5723 56.6797 83.3848C56.0234 83.1035 54.8516 82.541 53.1641 81.6973C53.7266 80.8535 54.1953 80.0566 54.5703 79.3066L51.6172 80.9941C51.5234 80.8066 51.2891 80.4316 50.9141 79.8691C50.1641 78.6504 49.6016 77.8066 49.2266 77.3379V79.7285C49.4141 82.2598 48.1016 83.5723 45.2891 83.666C44.2578 83.666 43.0391 83.666 41.6328 83.666C41.3516 82.6348 41.1172 81.6973 40.9297 80.8535C40.8359 80.9473 40.7422 81.0879 40.6484 81.2754C40.2734 81.6504 40.0391 81.9785 39.9453 82.2598L36.4297 80.291C36.6172 80.0098 36.8984 79.5879 37.2734 79.0254C37.6484 78.4629 38.3984 77.1504 39.5234 75.0879ZM45.5703 65.9473L43.6016 66.9316H46.6953C47.5391 65.9004 48.2891 64.916 48.9453 63.9785H43.4609C43.7422 64.166 44.1172 64.4941 44.5859 64.9629C45.0547 65.3379 45.3828 65.666 45.5703 65.9473ZM92.3984 58.4941H97.6016C97.6016 60.1816 97.5547 61.7754 97.4609 63.2754H105.898C105.898 68.2441 105.805 73.166 105.617 78.041C105.617 81.5098 104.023 83.2441 100.836 83.2441C99.0547 83.3379 97.3672 83.3848 95.7734 83.3848C95.6797 83.0098 95.4922 82.166 95.2109 80.8535C95.1172 80.3848 95.0234 80.0098 94.9297 79.7285C93.9922 81.2285 92.7734 82.6348 91.2734 83.9473C90.9922 83.8535 90.5703 83.7129 90.0078 83.5254C88.4141 82.9629 87.1016 82.4004 86.0703 81.8379C86.6328 81.3691 87.1484 80.9473 87.6172 80.5723C86.3047 80.666 84.4297 80.8066 81.9922 80.9941C80.5859 81.0879 79.6016 81.1348 79.0391 81.1348C77.2578 81.2285 75.7578 81.4629 74.5391 81.8379L72.8516 78.1816C73.6016 77.6191 74.1641 77.0098 74.5391 76.3535C75.5703 74.666 76.5078 72.6504 77.3516 70.3066H72.9922V66.5098H89.4453V70.3066H82.9766C81.7578 72.9316 80.5859 75.2285 79.4609 77.1973C80.2109 77.1973 81.8047 77.1035 84.2422 76.916C84.0547 76.3535 83.6797 75.6035 83.1172 74.666C82.6484 73.6348 82.3203 72.9316 82.1328 72.5566L86.3516 71.0098C87.4766 73.166 88.6484 75.5098 89.8672 78.041C91.3672 76.2598 92.1172 72.6035 92.1172 67.0723H89.7266V63.2754H92.2578C92.2578 61.8691 92.3047 60.2754 92.3984 58.4941ZM88.3203 60.041V63.6973H74.6797V60.041H88.3203ZM100.414 67.0723H97.3203C97.2266 72.6973 96.4766 76.7754 95.0703 79.3066C96.1016 79.4004 97.1797 79.4473 98.3047 79.4473C99.5234 79.4473 100.18 78.791 100.273 77.4785C100.273 76.7285 100.273 75.4629 100.273 73.6816C100.367 70.9629 100.414 68.7598 100.414 67.0723ZM141.898 61.166V64.9629H130.648C132.711 67.3066 136.836 68.8066 143.023 69.4629C142.742 70.0254 142.32 70.916 141.758 72.1348C141.383 72.9785 141.102 73.5879 140.914 73.9629C133.414 72.6504 128.539 70.3066 126.289 66.9316C125.727 67.6816 125.07 68.3379 124.32 68.9004C125.445 69.5566 126.617 70.2598 127.836 71.0098L124.461 73.9629C123.055 72.8379 121.789 71.9004 120.664 71.1504C118.32 72.2754 115.227 73.3066 111.383 74.2441C111.289 74.0566 111.055 73.6348 110.68 72.9785C109.93 71.4785 109.367 70.4473 108.992 69.8848C115.836 68.666 120.102 67.0254 121.789 64.9629H110.117V61.166H122.914C123.008 60.416 123.055 59.5254 123.055 58.4941H129.102C129.008 59.5254 128.961 60.416 128.961 61.166H141.898ZM133.742 75.6504L137.961 73.541C139.93 75.8848 141.617 78.041 143.023 80.0098L138.383 82.4004C137.633 81.1816 136.836 80.0098 135.992 78.8848C135.898 79.541 135.711 80.1973 135.43 80.8535C134.867 82.541 133.32 83.3848 130.789 83.3848H121.508C118.508 83.3848 117.008 81.8848 117.008 78.8848V74.2441H122.492V77.6191C122.398 79.0254 123.008 79.6816 124.32 79.5879H128.961C130.086 79.5879 130.742 79.0723 130.93 78.041C130.93 77.5723 131.023 76.9629 131.211 76.2129C131.586 76.3066 132.195 76.4941 133.039 76.7754C133.883 77.0566 134.492 77.2441 134.867 77.3379C134.773 77.1504 134.586 76.8691 134.305 76.4941C134.023 76.1191 133.836 75.8379 133.742 75.6504ZM108.711 80.8535C109.461 79.541 110.445 77.4785 111.664 74.666C111.57 74.7598 111.617 74.6191 111.805 74.2441L116.727 75.791C115.602 78.3223 114.477 80.6191 113.352 82.6816L108.711 80.8535ZM123.477 75.5098L126.852 72.6973C127.133 72.8848 127.602 73.2129 128.258 73.6816C129.477 74.5254 130.414 75.2285 131.07 75.791L127.555 78.7441C126.055 77.5254 124.695 76.4473 123.477 75.5098Z"
              fill="#14141E"
            />
          </svg>

          <svg
            v-else
            width="384"
            height="98"
            viewBox="0 0 384 98"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M159.78 7.86195L158.6 8.50195C158.26 7.54195 157.42 6.12195 156.62 5.08195L157.7 4.50195C158.56 5.52195 159.4 6.94195 159.78 7.86195ZM170.62 14.922H163.16C164.64 17.962 167.4 20.202 171.08 21.142C170.76 21.422 170.34 22.002 170.14 22.382C166.58 21.302 163.92 19.062 162.26 15.902C161.42 18.242 159.28 20.622 154.04 22.502C153.88 22.202 153.44 21.642 153.1 21.342C158.52 19.482 160.38 17.122 161 14.922H153.46V13.602H161.26C161.3 13.142 161.32 12.722 161.32 12.302V9.88195H154.64V8.58195H164.04C164.84 7.38195 165.74 5.64195 166.26 4.38195L167.68 4.88195C167.04 6.10195 166.22 7.48195 165.46 8.58195H169.54V9.88195H162.8V12.322C162.8 12.742 162.78 13.162 162.74 13.602H170.62V14.922ZM185.94 7.46195L184.66 7.98195C184.38 7.10195 183.64 5.70195 182.96 4.66195L184.16 4.22195C184.86 5.22195 185.64 6.60195 185.94 7.46195ZM178.5 6.62195L177.72 7.70195C176.88 7.06195 175.26 6.10195 173.96 5.48195L174.68 4.52195C175.96 5.10195 177.64 5.98195 178.5 6.62195ZM177.34 12.022L176.6 13.142C175.78 12.502 174.18 11.582 172.92 10.962L173.66 9.98195C174.86 10.562 176.5 11.422 177.34 12.022ZM177.3 14.942L178.26 15.802C177.22 17.902 175.8 20.422 174.64 22.282L173.52 21.362C174.6 19.842 176.16 17.202 177.3 14.942ZM185.32 20.602H191.14V21.882H178V20.602H183.96V15.282H179.4V14.022H183.96V9.38195H178.62V8.10195H190.7V9.38195H185.32V14.022H189.96V15.282H185.32V20.602ZM210.32 8.16195L209.24 8.94195C208.6 8.00195 207.24 6.56195 206.04 5.52195L207.06 4.84195C208.24 5.82195 209.64 7.24195 210.32 8.16195ZM208.66 12.442L209.84 12.942C208.94 14.642 207.74 16.262 206.34 17.702C207.1 19.922 208.06 21.242 209.14 21.242C209.7 21.242 209.96 20.202 210.08 17.622C210.36 17.882 210.84 18.182 211.2 18.322C210.96 21.602 210.46 22.582 209.02 22.582C207.42 22.582 206.18 21.122 205.26 18.742C203.94 19.902 202.46 20.942 200.96 21.762C200.74 21.422 200.34 20.982 200.02 20.702C201.72 19.862 203.36 18.722 204.8 17.382C204.32 15.702 203.94 13.702 203.68 11.482H198.86V14.862C200.06 14.602 201.28 14.322 202.5 14.042L202.6 15.242L198.86 16.122V20.742C198.86 21.662 198.62 22.062 198.04 22.282C197.42 22.502 196.38 22.562 194.74 22.542C194.68 22.162 194.44 21.582 194.24 21.202C195.54 21.242 196.72 21.222 197.06 21.202C197.42 21.202 197.54 21.102 197.54 20.742V16.442C196 16.822 194.52 17.142 193.3 17.422L192.92 16.082C194.14 15.862 195.78 15.522 197.54 15.122V11.482H193.18V10.222H197.54V6.84195C196.26 7.10195 194.98 7.32195 193.76 7.50195C193.7 7.18195 193.5 6.72195 193.34 6.40195C196.12 5.96195 199.38 5.26195 201.24 4.56195L202.2 5.66195C201.24 5.98195 200.1 6.30195 198.86 6.58195V10.222H203.54C203.38 8.40195 203.28 6.44195 203.26 4.46195H204.64C204.64 6.50195 204.72 8.42195 204.9 10.222H210.84V11.482H205.04C205.26 13.282 205.54 14.882 205.9 16.282C207.02 15.082 207.96 13.802 208.66 12.442ZM216.64 4.42195L217.84 4.74195C217.44 6.20195 216.9 7.68195 216.32 9.04195V22.502H215.04V11.662C214.56 12.502 214.08 13.262 213.56 13.942C213.44 13.642 213.06 12.942 212.82 12.642C214.4 10.602 215.78 7.50195 216.64 4.42195ZM218.86 22.522V8.24195H220.16V22.522H218.86ZM219.7 4.84195L220.74 4.32195C221.62 5.52195 222.64 7.14195 223.12 8.14195L222.02 8.76195C221.58 7.74195 220.58 6.08195 219.7 4.84195ZM230.36 5.04195V20.742C230.36 21.622 230.14 22.002 229.56 22.222C228.98 22.462 227.96 22.462 226.42 22.462C226.36 22.122 226.14 21.542 225.96 21.182C227.14 21.222 228.26 21.222 228.58 21.202C228.92 21.182 229.04 21.082 229.04 20.742V6.26195H223.52V5.04195H230.36Z"
              fill="#14141E"
            />
            <path
              d="M48 36.252V39.752H62.25V46.252H48V48.502H38V46.252H27.5V48.252H23.25L27.75 52.502C26.9167 53.002 25.6667 53.752 24 54.752C22.5 55.5853 21.3333 56.252 20.5 56.752C22.6667 60.5853 23.75 65.6686 23.75 72.002C23.75 72.1686 23.6667 72.502 23.5 73.002C23.5 73.502 23.5 73.9186 23.5 74.252C30.6667 71.0853 34.6667 67.1686 35.5 62.502H25V56.252H36C36.1667 54.9186 36.25 52.6686 36.25 49.502H46.25C46.0833 52.002 46 54.252 46 56.252H53C52.3333 55.752 51.3333 55.002 50 54.002C49 53.1686 48.1667 52.502 47.5 52.002L52 47.752C52.8333 48.4186 54 49.252 55.5 50.252C57.1667 51.252 58.4167 52.0853 59.25 52.752L55.75 56.252H61.25V62.502H47C49 67.8353 54.0833 71.5853 62.25 73.752C61.75 74.4186 60.9167 75.6686 59.75 77.502C58.75 79.1686 58 80.3353 57.5 81.002C49.8333 78.6686 44.5833 74.9186 41.75 69.752C39.5833 74.0853 35 77.9186 28 81.252C27.5 80.9186 26.4167 79.752 24.75 77.752C24.0833 76.9186 23.5833 76.3353 23.25 76.002C22.25 79.3353 19.1667 81.002 14 81.002C12 81.002 9.33333 81.002 6 81.002C5.66667 79.8353 5.16667 77.9186 4.5 75.252C7 75.252 9.16667 75.252 11 75.252C13.6667 75.4186 14.9167 74.252 14.75 71.752C14.75 70.752 14.75 69.8353 14.75 69.002C10.9167 71.3353 7.5 73.1686 4.5 74.502C4.16667 73.6686 3.5 72.3353 2.5 70.502C2 69.6686 1.66667 69.002 1.5 68.502C6.16667 66.502 10.1667 64.4186 13.5 62.252C13.5 62.0853 13.4167 61.8353 13.25 61.502C13.0833 61.002 12.9167 60.6686 12.75 60.502C10.4167 61.6686 7.75 62.752 4.75 63.752C3.41667 61.4186 2.33333 59.4186 1.5 57.752C2.66667 57.4186 4.41667 56.8353 6.75 56.002C7.75 55.6686 8.5 55.4186 9 55.252C7.33333 53.5853 5.58333 52.252 3.75 51.252L10.25 46.752C12.75 48.252 14.8333 49.8353 16.5 51.502C17.1667 51.1686 18.1667 50.5853 19.5 49.752C20.5 49.0853 21.25 48.5853 21.75 48.252H17.25V46.252H1.75V39.752H17.25V36.252H27.5V39.752H38V36.252H48ZM97.75 73.252C97.4167 73.252 96.9167 73.3353 96.25 73.502C95.5833 73.502 95.0833 73.5853 94.75 73.752V81.002H86V74.752C84.5 74.9186 82.3333 75.1686 79.5 75.502C74 76.1686 69.6667 76.6686 66.5 77.002L65.25 70.002C65.75 70.002 66.4167 70.002 67.25 70.002C68.25 69.8353 69 69.752 69.5 69.752V45.002H66.5V38.502H97V45.002H94.75V67.002C95.0833 67.002 95.5833 67.002 96.25 67.002C96.9167 66.8353 97.5 66.752 98 66.752C97.8333 69.4186 97.75 71.5853 97.75 73.252ZM106.5 47.002C107.5 53.502 109 58.3353 111 61.502C113 57.8353 114.417 52.9186 115.25 46.752H98V39.752H124.5V46.752C123.167 55.9186 120.667 63.0853 117 68.252C118.667 69.752 121.833 71.6686 126.5 74.002C125.167 76.002 123.583 78.3353 121.75 81.002C117.583 79.1686 114 77.0853 111 74.752C108.167 77.252 104.75 79.502 100.75 81.502C99.75 80.502 97.9167 78.3353 95.25 75.002C99.25 72.8353 102.583 70.6686 105.25 68.502C101.583 63.8353 99.0833 57.252 97.75 48.752L106.5 47.002ZM78 54.752V58.752H86V54.752H78ZM78 45.002V49.252H86V45.002H78ZM78 68.752C80.8333 68.4186 83.5 68.1686 86 68.002V64.252H78V68.752ZM130.5 80.252L129.75 74.752C131.25 74.752 132.75 74.752 134.25 74.752V59.502H129.75V54.252H190.25V59.502H160.25V73.502L163.25 73.252C163.083 73.9186 163 74.5853 163 75.252C164.667 74.752 166.25 74.252 167.75 73.752C165.75 72.252 163.917 70.502 162.25 68.502L166.25 66.502H161.5V61.252H187.5V67.252C187.167 67.5853 186.667 68.1686 186 69.002C185.167 70.1686 183.75 71.6686 181.75 73.502C184.25 74.1686 187.167 74.752 190.5 75.252C190.333 75.752 189.917 76.4186 189.25 77.252C188.25 79.0853 187.5 80.3353 187 81.002C182 80.3353 177.917 79.252 174.75 77.752C171.75 79.252 168.167 80.4186 164 81.252C163.5 80.9186 162.833 80.0853 162 78.752C161.333 78.752 160.75 78.752 160.25 78.752V81.002H151.5V79.252C143.167 79.5853 136.167 79.9186 130.5 80.252ZM183.75 38.002V53.002H136.25V38.002H183.75ZM146.25 48.752H173.75V47.252H146.25V48.752ZM146.25 42.502V44.002H173.75V42.502H146.25ZM170 66.502C171.5 68.002 173.083 69.252 174.75 70.252C175.083 70.0853 175.5 69.752 176 69.252C177.333 68.252 178.333 67.3353 179 66.502H170ZM143 74.252C143.833 74.252 145.167 74.252 147 74.252C149 74.0853 150.5 74.002 151.5 74.002V72.002H143V74.252ZM143 65.752V68.002H151.5V65.752H143ZM143 59.502V61.752H151.5V59.502H143ZM198.25 65.752L204.75 68.502C203.75 70.502 202.667 72.502 201.5 74.502C201.833 74.6686 202.25 74.752 202.75 74.752C203.417 74.5853 203.833 74.502 204 74.502C205.667 74.6686 206.417 73.9186 206.25 72.252V65.502H195V59.502H206.25V57.252H194V51.252H200.25C199.25 49.9186 198.167 48.752 197 47.752L200.75 46.002H195.25V40.002H205C204.833 39.502 204.583 38.8353 204.25 38.002C204.083 37.1686 203.917 36.5853 203.75 36.252L214.5 35.502C214.667 36.1686 214.833 37.002 215 38.002C215.333 38.8353 215.5 39.502 215.5 40.002H225V46.002H219.5L223.75 47.252C223.417 47.5853 222.833 48.252 222 49.252C221.333 50.0853 220.75 50.752 220.25 51.252H226V57.252H215.5V59.502H225.25V65.502H215.5V69.002L221.5 66.002C221.833 66.6686 222.417 67.502 223.25 68.502C223.917 69.1686 224.667 70.252 225.5 71.752C226.833 69.252 227.417 64.502 227.25 57.502V39.502C237.75 39.002 245.75 38.252 251.25 37.252L253.5 44.002C251 44.3353 247 44.752 241.5 45.252C239.5 45.252 237.917 45.3353 236.75 45.502V51.252H254.25V58.002H249.5V80.752H240.5V58.002H236.75C236.75 68.3353 234.917 76.0853 231.25 81.252C230.75 81.0853 229.917 80.8353 228.75 80.502C227.583 80.002 225.5 79.002 222.5 77.502C223.5 76.002 224.333 74.5853 225 73.252L219.75 76.252C219.583 75.9186 219.167 75.252 218.5 74.252C217.167 72.0853 216.167 70.5853 215.5 69.752V74.002C215.833 78.502 213.5 80.8353 208.5 81.002C206.667 81.002 204.5 81.002 202 81.002C201.5 79.1686 201.083 77.502 200.75 76.002C200.583 76.1686 200.417 76.4186 200.25 76.752C199.583 77.4186 199.167 78.002 199 78.502L192.75 75.002C193.083 74.502 193.583 73.752 194.25 72.752C194.917 71.752 196.25 69.4186 198.25 65.752ZM209 49.502L205.5 51.252H211C212.5 49.4186 213.833 47.6686 215 46.002H205.25C205.75 46.3353 206.417 46.9186 207.25 47.752C208.083 48.4186 208.667 49.002 209 49.502ZM292.25 36.252H301.5C301.5 39.252 301.417 42.0853 301.25 44.752H316.25C316.25 53.5853 316.083 62.3353 315.75 71.002C315.75 77.1686 312.917 80.252 307.25 80.252C304.083 80.4186 301.083 80.502 298.25 80.502C298.083 79.8353 297.75 78.3353 297.25 76.002C297.083 75.1686 296.917 74.502 296.75 74.002C295.083 76.6686 292.917 79.1686 290.25 81.502C289.75 81.3353 289 81.0853 288 80.752C285.167 79.752 282.833 78.752 281 77.752C282 76.9186 282.917 76.1686 283.75 75.502C281.417 75.6686 278.083 75.9186 273.75 76.252C271.25 76.4186 269.5 76.502 268.5 76.502C265.333 76.6686 262.667 77.0853 260.5 77.752L257.5 71.252C258.833 70.252 259.833 69.1686 260.5 68.002C262.333 65.002 264 61.4186 265.5 57.252H257.75V50.502H287V57.252H275.5C273.333 61.9186 271.25 66.002 269.25 69.502C270.583 69.502 273.417 69.3353 277.75 69.002C277.417 68.002 276.75 66.6686 275.75 65.002C274.917 63.1686 274.333 61.9186 274 61.252L281.5 58.502C283.5 62.3353 285.583 66.502 287.75 71.002C290.417 67.8353 291.75 61.3353 291.75 51.502H287.5V44.752H292C292 42.252 292.083 39.4186 292.25 36.252ZM285 39.002V45.502H260.75V39.002H285ZM306.5 51.502H301C300.833 61.502 299.5 68.752 297 73.252C298.833 73.4186 300.75 73.502 302.75 73.502C304.917 73.502 306.083 72.3353 306.25 70.002C306.25 68.6686 306.25 66.4186 306.25 63.252C306.417 58.4186 306.5 54.502 306.5 51.502ZM380.25 41.002V47.752H360.25C363.917 51.9186 371.25 54.5853 382.25 55.752C381.75 56.752 381 58.3353 380 60.502C379.333 62.002 378.833 63.0853 378.5 63.752C365.167 61.4186 356.5 57.252 352.5 51.252C351.5 52.5853 350.333 53.752 349 54.752C351 55.9186 353.083 57.1686 355.25 58.502L349.25 63.752C346.75 61.752 344.5 60.0853 342.5 58.752C338.333 60.752 332.833 62.5853 326 64.252C325.833 63.9186 325.417 63.1686 324.75 62.002C323.417 59.3353 322.417 57.502 321.75 56.502C333.917 54.3353 341.5 51.4186 344.5 47.752H323.75V41.002H346.5C346.667 39.6686 346.75 38.0853 346.75 36.252H357.5C357.333 38.0853 357.25 39.6686 357.25 41.002H380.25ZM365.75 66.752L373.25 63.002C376.75 67.1686 379.75 71.002 382.25 74.502L374 78.752C372.667 76.5853 371.25 74.502 369.75 72.502C369.583 73.6686 369.25 74.8353 368.75 76.002C367.75 79.002 365 80.502 360.5 80.502H344C338.667 80.502 336 77.8353 336 72.502V64.252H345.75V70.252C345.583 72.752 346.667 73.9186 349 73.752H357.25C359.25 73.752 360.417 72.8353 360.75 71.002C360.75 70.1686 360.917 69.0853 361.25 67.752C361.917 67.9186 363 68.252 364.5 68.752C366 69.252 367.083 69.5853 367.75 69.752C367.583 69.4186 367.25 68.9186 366.75 68.252C366.25 67.5853 365.917 67.0853 365.75 66.752ZM321.25 76.002C322.583 73.6686 324.333 70.002 326.5 65.002C326.333 65.1686 326.417 64.9186 326.75 64.252L335.5 67.002C333.5 71.502 331.5 75.5853 329.5 79.252L321.25 76.002ZM347.5 66.502L353.5 61.502C354 61.8353 354.833 62.4186 356 63.252C358.167 64.752 359.833 66.002 361 67.002L354.75 72.252C352.083 70.0853 349.667 68.1686 347.5 66.502Z"
              fill="#14141E"
            />
          </svg>
        </div>
      </div>
      <template v-if="joinUsData && joinUsData.data">
        <JoinUsMb
          v-if="isMobile"
          ref="joinus"
          v-dom-hook="intersctionOption"
          :data="joinUsData && joinUsData.data"
          :show-service="false"
        />
        <JoinUs
          v-else
          ref="joinus"
          v-dom-hook="intersctionOption"
          :data="joinUsData && joinUsData.data"
          :show-service="false"
        />
      </template>
    </div>
  </div>
</template>

<script>
import { useBasic, useLandingPage } from '@speedshop/sdk-api';
import { pageMixinCommon } from '@speedshop/template';

// import { Tabs, TabPane } from 'element-ui';
import uaParser from 'ua-parser-js';
import LandingPage from '@/components/LandingPage/index.vue';
import JoinUs from '@/components/PersonalCenter/joinUs.vue';
import JoinUsMb from '@/components/PersonalCenter/joinUsMobile.vue';
import { getThirdQrCode } from '@/graphql/lp.gql';
import { scrollToTopW } from '@/utils/dom';
import Tab from '@/components/LandingPage/tab.vue';
import defer from '@/mixins/defer';

export default {
  name: 'LP',
  components: {
    LandingPage,
    // Tabs,
    // TabPane,
    Tab,
    JoinUsMb,
    JoinUs
  },
  mixins: [pageMixinCommon, defer()],
  scrollToTop: true,
  async asyncData({ route, store }) {
    const { path, query } = route;

    const ColumnList = {
      homeColumnList: [],
      menColumnList: [],
      womenColumnList: [],
      curryColumnList: []
    };
    let seoInfo = {};

    const LandingPage = useLandingPage();
    try {
      const list = [
        { pageUrl: '/page/new-home', key: 'homeColumnList' }
        // { pageUrl: '/new-mens', key: 'menColumnList' },
        // { pageUrl: '/new-women', key: 'womenColumnList' },
        // { pageUrl: '/curry', key: 'curryColumnList' }
      ];
      const fetchList = list.map(async item => {
        const { landingData, seoInfo: pageSeoInfo } = await LandingPage.init({
          pageUrl: item.pageUrl,
          deviceType: store.getters.isMobile === true ? 'h5' : 'pc',
          preview: query.preview === 'true',
          cacheFlag: query.preview !== 'true'
        });

        ColumnList[item.key] = landingData;

        if (item.pageUrl === '/page/new-home') {
          seoInfo = pageSeoInfo;
        }
      });
      await Promise.all(fetchList);
      return {
        ...ColumnList,
        seoInfo,
        ColumnList
      };
    } catch (e) {
      console.log(e, 'lp error');
      return {
        ...ColumnList,
        seoInfo,
        ColumnList
      };
    }
  },
  data() {
    const tabList = [
      {
        pageName: '首页男子系列',
        pageUrl: '/new-mens',
        title: '男子'
      },
      {
        pageName: '首页女子系列',
        pageUrl: '/new-women',
        title: '女子'
      },
      {
        pageName: '首页CURRY系列',
        pageUrl: '/curry',
        title: 'CURRY品牌'
      }
    ];
    return {
      fetched: false,
      joinUsData: {},
      stickyTop: this.isMobile ? 94 : 100,
      ColumnList: {},
      seoInfo: {},
      homeColumnList: [],
      // curryColumnList: [],
      // menColumnList: [],
      // womenColumnList: [],
      loading: true,
      activeValue: 'man',
      womanLoaded: false,
      curryLoaded: false,
      manLoaded: false,
      // tabList: [
      //   {
      //     label: '男子',
      //     value: 'man',
      //     url: '/new-mens',
      //     list: 'menColumnList'
      //   },
      //   {
      //     label: '女子',
      //     value: 'woman',
      //     url: '/new-women',
      //     list: 'womenColumnList'
      //   },
      //   {
      //     label: 'CURRY品牌',
      //     value: 'curry',
      //     url: '/curry',
      //     list: 'curryColumnList'
      //   }
      // ],
      tabData: {
        content: {
          list: tabList,
          widgetItem: {
            widgetCode: 'widget-tab-sticky-to-top'
          }
        },
        couselList: tabList.map(tab => ({
          ...tab,
          url: tab.pageUrl
        })),
        customizedClassName: 'Tab 红色文字',
        customizedStyle: '<style></style>',
        // layoutId: 'widget-collection-selection',
        operationData: {},
        position: 'top',
        // style: {},
        type: 'tab'
      },
      isQQ: false,
      intersctionObserver: undefined,
      intersctionOption: {
        bind: el => {
          this.observerJoinUsHandle(el);
        },
        unbind: () => {
          this.intersctionObserver?.disconnect?.();
        }
      }
    };
  },
  head() {
    const { seoTitle = '', seoDesc = '', seoKeyword = '' } = this.seoInfo || {};
    const head = { meta: [] };
    if (seoTitle) {
      head.title = seoTitle;
    }
    if (seoDesc) {
      head.meta.push({
        hid: 'description',
        name: 'description',
        content: seoDesc
      });
    }
    if (seoKeyword) {
      head.meta.push({
        hid: 'keywords',
        name: 'keywords',
        content: seoKeyword
      });
    }
    return head;
  },
  watch: {
    activeValue(val) {
      if (val === 'woman') {
        this.womanLoaded = true;
      } else if (val === 'curry') {
        this.curryLoaded = true;
      }
      // const tab = document.querySelector('.home-category-lp');
      // const boundingData = tab.getBoundingClientRect();

      const tabHeader = document.querySelector('.category-lp-tab ');
      // const header = this.isMobile
      //   ? document.querySelector('.mobile_header-layer')
      //   : document.querySelector('.gt-header ');
      this.$nextTick(() => {
        const $container = this.$refs[val]?.$el;
        const noAd = document.querySelector('.gt-layout-without-ad');
        const stickyTop = this.isMobile && noAd ? 54 : this.isMobile ? 94 : 65;
        // if (boundingData.top > stickyTop) {
        //   this.$nextTick(() => {
        //     this.lazyLoad();
        //   });
        //   return;
        // }

        this.$nextTick(() => {
          // this.lazyLoad();
          const Top =
            window.scrollY +
            $container.getBoundingClientRect().top -
            stickyTop -
            tabHeader?.clientHeight;
          scrollToTopW(Top);
        });
      });
    }
  },
  mounted() {
    this.seoInfo.seoTitle && (this.$route.meta.title = this.seoInfo.seoTitle);
    this.$nextTick(() => {
      this.loading = false;
      this.observerScroll();
    });
    this.getDevice();
  },
  beforeDestroy() {
    document.removeEventListener('scroll', this.listenerScroll);
  },
  methods: {
    getDevice() {
      const parser = uaParser(navigator.userAgent);
      this.isQQ = parser.browser?.name === 'QQBrowser';
    },
    // scrollToTop(targetY, duration) {
    //   const cubic = value => Math.pow(value, 3);
    //   const easeInOutCubic = value =>
    //     value < 0.5 ? cubic(value * 2) / 2 : 1 - cubic((1 - value) * 2) / 2;
    //   const el = document.documentElement;
    //   const beginTime = Date.now();
    //   const beginValue = el.scrollTop;
    //   const rAF = window.requestAnimationFrame || (func => setTimeout(func, 16));
    //   const frameFunc = () => {
    //     const progress = (Date.now() - beginTime) / 500;
    //     if (progress < 1) {
    //       el.scrollTop = beginValue * (1 - easeInOutCubic(progress));
    //       rAF(frameFunc);
    //     } else {
    //       el.scrollTop = 0;
    //     }
    //   };
    //   rAF(frameFunc);
    // },
    // handleChangeTab(val) {
    //   console.log(val, 888);
    // },
    // lazyLoad() {
    //   const images = document.querySelectorAll('img[data-src]');
    //   images.forEach(image => {
    //     if (this.isInViewport(image)) {
    //       image.src = image.getAttribute('data-src');
    //       image.removeAttribute('data-src');
    //     }
    //   });
    // },
    isInViewport(element) {
      const rect = element.getBoundingClientRect();

      return (
        rect.bottom > 0 &&
        rect.top < (window.innerHeight || document.documentElement?.clientHeight) + 200
      );
    },
    async getCategoryData() {
      this.fetched = true;
      const LandingPage = useLandingPage();
      try {
        // const list = [
        //   { pageUrl: '/new-mens', key: 'menColumnList' },
        //   { pageUrl: '/new-women', key: 'womenColumnList' },
        //   { pageUrl: '/curry', key: 'curryColumnList' }
        // ];
        const fetchList = this.tabData.couselList.map(async item => {
          const { landingData } = await LandingPage.init({
            pageUrl: item.pageUrl,
            deviceType: this.isMobile ? 'h5' : 'pc',
            preview: this.$route.query.preview === 'true',
            cacheFlag: this.$route.query.preview !== 'true'
          });
          // console.log('uniqueNavElements 11', landingData);
          // this[item.key] = landingData;
          // this.ColumnList[item.key] = landingData;
          item.list = landingData;
        });
        await Promise.all(fetchList);
        this.$nextTick(() => {
          this.manLoaded = true;
          setTimeout(() => {
            const videoStickyModule = document.querySelector('.widget-widget-meridian-brand');
            if (this.isQQ && videoStickyModule) {
              const row = videoStickyModule.querySelectorAll('.sp-row');
              const video = row[1];
              video.style.position = 'relative';
              video.style.top = 0;
              console.log(video);
            }
          }, 500);
        });
      } catch {}
    },
    observerScroll() {
      document.addEventListener('scroll', this.listenerScroll);
    },
    listenerScroll() {
      if (!this.fetched) {
        // this.getCategoryData();
        this.getJoinUsData();
      }
      // const $el = document.querySelector('.home-category-lp');
      // const boundingData = $el.getBoundingClientRect();

      // const computedStyle = window.getComputedStyle($el);
      // const top = computedStyle.getPropertyValue('top');
      // if (boundingData.top <= parseFloat(top)) {
      //   $el.classList.add('home-category-lp-shadow');
      // } else {
      //   $el.classList.remove('home-category-lp-shadow');
      // }
    },
    async getJoinUsData() {
      this.fetched = true;
      const Basic = useBasic();
      const { data } = await Basic.gqlClient.query(getThirdQrCode, {
        deviceType: this.isMobile ? 'h5' : 'pc'
      });
      this.joinUsData = data;
      this.$nextTick(() => {});
    },
    observerJoinUsHandle(el) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.intersectionRatio <= 0) return;
          const target = entry.target;
          const LastChild = this.menColumnList[this.menColumnList.length - 1];
          this.$trackHelp.track('operationExpose', {
            expose_type: '手动切换',
            module_name: '关注我们',
            operation_name: '图片',
            operation_rank: 1,
            module_rank: LastChild?.operationData?.module_rank
          });
          observer.unobserve(target);
        });
      });
      observer.observe(el);
    }
  }
};
</script>
<style lang="scss">
.page-home {
  .follow-us {
    width: 85%;
    margin: 60px auto 120px auto;
    .ua-personal-center__join-us {
      padding-top: 0px;
    }
  }
}
.page-layout_pc {
  .category-lp {
  }
}
.page-layout_mobile {
  .follow-us {
    margin: 32px auto 64px auto;
    width: 100%;
    padding: 0px 20px;
    .ua-personal-center__join-us {
      padding-top: 0px;
    }
    .ua-personal-center-mb__join-us {
      background: none;
      padding-bottom: 0px;
      .ua-personal-center-mb__join-us-wrapper {
        width: 100%;
        margin-left: 0px;
        .swiper-pagination {
          margin-top: 10px;
        }
        .sp-swiper-container {
          padding: 0;
          background: var(--bg-for-product, #f7f7f7);
          .swiper-slide {
            .gt-button.el-button.el-button--plain,
            .gt-image-container {
              background: var(--bg-for-product, #f7f7f7) !important;
            }
          }
        }
      }
    }
  }
}
.page-layout_pc .category-lp {
  // background: var(--main-color-ua-white, #fff);

  // &.home-category-lp-shadow {
  //   /* 吸顶-投影 */
  //   box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
  // }
  // .el-tabs__content {
  //   overflow: initial;
  // }
  .sp-landing-swiper-tab {
    > .gt-tabs {
      top: var(--pc-sticky-top-default) !important;
      display: flex;
      justify-content: center;
      // padding: 12px 0px;
      margin: 60px 0;
      .el-tabs__header {
        margin: 0px;
      }
      .el-tabs__nav-wrap {
        justify-content: center;
      }
    }
  }

  // .sp-landing-tab-content .sp-landing-page.sp-landingpage-collection > .sp-row {
  //   margin: 0 auto;
  //   padding: 0 7.5%;
  // }
}
.page-layout_mobile {
  &.gt-layout-without-ad {
    .category-lp {
      top: 54px;
    }
  }
  .category-lp {
    margin-top: 32px;
    > .sp-landing-swiper-tab > .gt-tabs {
      // top: 94px !important;
      margin-bottom: 8px;
      margin-top: 0px;
      .el-tabs__header {
        margin: 0px;
      }
      .el-tabs__nav-wrap {
        justify-content: center;
      }
    }
  }
  .home-category-lp {
    &.category-lp {
      .gt-tabs.el-tabs {
        justify-content: flex-start;
        .el-tabs__nav-wrap {
          justify-content: flex-start;
        }
      }
    }
  }
  // .category-lp {
  //   top: 94px;
  //   background: var(--main-color-ua-white, #fff);
  //   margin-top: 32px;
  //   .gt-tabs.el-tabs {
  //     .el-tabs__item {
  //       padding: 0px 24px;
  //     }
  //   }

  //   .category-lp-tab.gt-tabs.el-tabs {
  //     margin-bottom: 8px;
  //     margin-top: 0px;
  //   }
  //   &.home-category-lp-shadow {
  //     box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
  //   }
  //   /* 吸顶-投影 */
  // }
}
</style>
